export function injectCss(css, onError = (err) => {}) {
  try {
    var head = document.getElementsByTagName("HEAD")[0];
    var styleSheet = document.createElement("style");
    styleSheet.textContent = css;
    head.appendChild(styleSheet);
  } catch (err) {
    onError(err);
  }
}

export function injectJs(src, cb = () => {}, onError = (err) => {}) {
  var head = document.getElementsByTagName("HEAD")[0];
  var el = document.createElement("script");
  el.src = src;
  head.appendChild(el);
  el.onload = cb;
  el.onerror = (err) => {
    onError(err);
  };
}

export function injectStyle(url, onError = (err) => {}) {
  var head = document.getElementsByTagName("HEAD")[0];
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = url;
  link.onerror = (err) => {
    onError(err);
  };

  head.appendChild(link);
}
